<template>
  <div class="vote-container" :class="tplClass">
    <top-banner :defaultPic="false" :data="data"></top-banner>
    <div class="vote-intro" v-if="type">
      <div class="vote-intro-title">活动说明</div>
      <div class="vote-intro-body">
        <div class="vote-intro-body-inner" v-html="data.description"></div>
        <a href="javascript:void(0)" class="body-extend" @click.prevent="showMore">展开<span class="icon"></span>
        </a>
      </div>
    </div>
    <count-down v-if="data.etime && data.countdown_display == '1'" :etime="data.etime"></count-down>
    <vote-summary :data="data" v-if="dataLen && type == 0"></vote-summary>
    <div class="tab-tip" v-if="this.$utils.getUrlParams('id') == 'ODMzOmJiNDdl'">左滑查看更多选项</div>
    <van-tabs v-model="activeTab" animated :ellipsis="false" @change="changeTab" v-if="dataLen && type == 1">
      <van-tab v-for="(item, i) in tabData" :key="i" :title="item.title" :name="item.title">
        <!-- <option-list v-if="dataLen" :id="item.id" :voteType="type.toString()" :type="item.type" 
          :optionListIndex="i" :data="item" :coverPic="data.cover_pic" :isEnded="isEnded"
          :wechatPreviewOnly="wechatPreviewOnly" :wechatCanVote="wechatCanVote" :weixinJumpUrl="weixinJumpUrl">
        </option-list> -->
      </van-tab>
    </van-tabs>
    <option-list v-if="dataLen" :voteType="type.toString()" :id="voteId" :data="optionListData" :isEnded="isEnded" :optionListIndex="activeTab"
      :activeTab="activeTab" :coverPic="data.cover_pic" :type="optionType" :wechatPreviewOnly="wechatPreviewOnly"
      :wechatCanVote="wechatCanVote" :weixinJumpUrl="weixinJumpUrl"></option-list>
  </div>
</template>

<script>
import TopBanner from "../components/TopBanner";
import VoteSummary from "../components/VoteSummary";
import CountDown from "../components/CountDown";
import OptionList from "../components/OptionList";

export default {
  name: "Vote",
  data() {
    return {
      // countDown: false,
      tplClass: "",
      // data: {},
      // dataLen: 0,
      // isEnded: false,
      apiParams: {
        id: "",
        isPreview: 0,
      },
      wechatCanVote: false,
      wechatPreviewOnly: false,
      weixinJumpUrl: "",
      // 组合投票才有用，默认第一个
      activeTab: 0,
    };
  },
  components: {
    TopBanner,
    VoteSummary,
    CountDown,
    OptionList,
  },
  computed: {
    data() {
      return this.$store.state.voteInfo;
    },
    dataLen() {
      return Object.keys(this.data).length;
    },
    // 1，投票组 0，普通投票
    type() {
      return this.data.vote_list && this.data.vote_list.length ? 1 : 0;
    },
    // 投票id
    voteId() {
      // 单一投票在 data 里
      // 多选投票在 data.vote_list 的每个子元素里
      if (this.type == 0) {
        return this.data.id
      } else {
        return this.data.vote_list[this.activeTab].id
      }
    },
    optionListData() {
      // 单一投票 data 
      // 组合投票 data.vote_list 每个子元素
      if (this.type == 0) {
        return this.data
      } else {
        return this.data.vote_list[this.activeTab]
      }
    },
    optionType() {
      // 投票方式 1，单选 2，多选
      // 单一投票在 data 里
      // 组合投票在 data.vote_list 的每个子元素里
      if (this.type == 0) {
        return this.data.type ? this.data.type : null;
      } else {
        return this.data.vote_list[this.activeTab].type ? this.data.vote_list[this.activeTab].type : null;
      }
    },
    countDown() {
      return this.type ? false : true;
    },
    isEnded() {
      if (this.data.etime) {
        let now = new Date().getTime();
        let target = this.data.etime.substring(0, 19).replace(/-/g, "/");
        let timestamp = new Date(target).getTime();
        return now < timestamp ? false : true;
      }
    },
    tabData() {
      // console.log(this.data.vote_list);
      // this.data.vote_list = [
      //   {
      //     count: "0",
      //     id: "MTk0OjM3MzIy",
      //     status: "1",
      //     title: "投票一投票一投票一投票一",
      //     type: "1",
      //     view_count: "7",
      //   },
      //   {
      //     count: "0",
      //     id: "MTk0OjM3MzIy",
      //     status: "1",
      //     title: "投票一",
      //     type: "1",
      //     view_count: "7",
      //   },
      //   {
      //     count: "0",
      //     id: "MTk0OjM3MzIy",
      //     status: "1",
      //     title: "投票一",
      //     type: "1",
      //     view_count: "7",
      //   },
      //   {
      //     count: "0",
      //     id: "MTk0OjM3MzIy",
      //     status: "1",
      //     title: "投票一",
      //     type: "1",
      //     view_count: "7",
      //   },
      // ];
      return this.data.vote_list;
    },
  },
  methods: {
    init() {
      // this.apiParams.id =
      //   this.$utils.getUrlParams("id") || this.$store.state.voteInfo.id;
      // this.apiParams.isPreview =
      //   this.$utils.getUrlParams("isPreview") ||
      //   this.$store.state.voteInfo.isPreview;
      // this.$get(this.$apis.voteInfo, this.apiParams).then((res) => {
      //   console.log("vote.vue，投票信息res===>", res);
      //   if (res.data.msg === "success") {
      //     this.data = res.data.data;
      //     this.dataLen = Object.keys(this.data);
      //     let now = new Date().getTime();
      //     let target = this.data.etime.substring(0, 19).replace(/-/g, "/");
      //     let timestamp = new Date(target).getTime();
      //     if (now < timestamp) {
      //       this.isEnded = false;
      //     } else {
      //       this.isEnded = true;
      //     }
      //     if (this.data.weixin_stint == 0) {
      //       this.wechatCanVote = true;
      //     } else if (
      //       this.data.weixin_stint == 1 &&
      //       this.data.weixin_restrict == 1
      //     ) {
      //       this.wechatPreviewOnly = true;
      //     }
      //     this.weixinJumpUrl = this.data.weixin_jump_url;
      //   } else {
      //     this.$toast.fail(res.data.msg);
      //   }
      // });

      if (this.data.weixin_stint == 0) {
        this.wechatCanVote = true;
      } else if (
        this.data.weixin_stint == 1 &&
        this.data.weixin_restrict == 1
      ) {
        this.wechatPreviewOnly = true;
      }
      this.weixinJumpUrl = this.data.weixin_jump_url;
    },
    showMore() {
      this.$nextTick(() => {
        let target = $(".vote-intro-body-inner");
        target.toggleClass("opened");
        // $(".body-extend").toggleClass("extended");
        if ($(".body-extend").hasClass("extended")) {
          $(".body-extend").removeClass("extended");
          $(".body-extend").html(`展开<span class="icon"></span>`);
        } else {
          $(".body-extend").addClass("extended");
          $(".body-extend").html(`收起<span class="icon"></span>`);
        }
      });
    },
    changeTab(index, title) {
      // console.log('changeTab index', index)
      // console.log('changeTab title', title)
      this.activeTab = index
      this.$store.commit("setActiveTab", index);
    },
  },
  created() {
    this.init();
  },
  watch: {},
};
</script>

<style>
.vote-container {
  /* height: 100%; */
}

.vote-banner {
  height: 3.7rem;
  /* background: url(../assets/images/bg-banner-top.png) center center no-repeat; */
  background-size: 100% 100%;
}

.vote-intro {
  padding: 0 0.2rem;
  margin: 0.2rem 0;
}

.vote-intro-title {
  height: 0.66rem;
  background: var(--themeColor);
  background-size: contain;
  font-size: 0.34rem;
  text-align: center;
  color: #fff;
  line-height: 0.66rem;
  margin: 0 auto;
}

.vote-intro-body {
  background: #fff;
  padding: 0.2rem;
  font-size: 0;
}

.vote-intro-body-inner {
  font-size: 0.3rem;
  line-height: 0.52rem;
  height: 2.08rem;
  min-height: 2.08rem;
  overflow: hidden;
  color: #666;
}

.vote-intro-body-inner.opened {
  height: auto;
}

.body-extend {
  text-align: center;
  color: var(--themeColor);
  font-size: 0.26rem;
  display: block;
  height: 0.5rem;
  line-height: 0.5rem;
}

.body-extend .icon {
  width: 0.24rem;
  height: 100%;
  display: inline-block;
  vertical-align: middle;
  background: url(../assets/images/arr-down-blue.png) center center no-repeat;
  background-size: 0.24rem;
  margin: 0 0.1rem;
}

.body-extend.extended .icon {
  background: url(../assets/images/arr-up-blue.png) center center no-repeat;
  background-size: 0.24rem;
}

.van-tabs {
  padding-left: 0.2rem;
  padding-right: 0.2rem;
}

.van-tabs--line .van-tabs__wrap {
  padding-left: 0.2rem;
  padding-right: 0.2rem;
}

.van-tab.van-tab--active {
  background: var(--themeColor);
  background-size: 100% 100%;
  color: #fff;
}

.van-tab {
  font-weight: bold;
  border-bottom: 0.03rem solid var(--themeColor);
  padding: 0 15px;
}

.van-tab span {
  /* font-weight: bold; */
  color: var(--themeColor);
  font-size: 0.36rem;
}

.van-tabs__line {
  display: none;
}

.van-tabs__nav {
  background: transparent;
}

[class*="van-hairline"]::after {
  display: none;
}

.van-tab.van-tab--active span {
  color: #fff;
}

.van-tabs__content--animated {
  /* overflow: visible !important; */
}

.tab-tip {
  font-size: 0.28rem;
  color: #999;
  text-align: center;
  margin: 0.1rem 0;
}
</style>